module.exports = __webpack_public_path__ + "public/img/产品保修 2.560c3325.png";